<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 214px;
  padding: 20px 0;
  box-sizing: border-box;
  overflow: hidden;

  .active-item {
    width: 100%;
    height: 32px;
    margin-bottom: 8px;
    line-height: 32px;
  }

  .active-item i, .active-item .item-name-num, .active-item span, .active-item em {
    float: left;
    height: 100%;
    color: #fff;
    font-size: 20px;
    font-style: normal;
    box-sizing: border-box;
  }

  .active-item .item-rank {
    width: 35px;
    color: #fff;
    text-align: center;
    margin-right: 8px;
  }

  .active-item .item-name-num {
    width: 400px;
    border-bottom: 1px solid rgba(0, 108, 243, 0.65);
    position: relative;
  }

  .active-item .item-name-num .item-name {
    padding-left: 30px;
    border-right: 1px solid rgba(0, 108, 243, 0.65);
    word-break: keep-all;
    background: linear-gradient(to right, #040B58, #0A30B1);
  }

  .active-item .item-name-num .item-num {
    float: right;
    font-size: 16px;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="data.length!=0">
        <swiper-slide v-for="(item,index) in data" :key="index" class="active-item">
          <i class="item-rank" :style="changeColor(index)">{{index+1}}</i>
          <div class="item-name-num">
            <span class="item-name" :style="changeLength(index)">{{item.name}}</span>
            <em class="item-num">{{item.num}}</em>
          </div>
        </swiper-slide>
      </swiper>

      <!-- <div class="active-item" v-for="(item,index) in data" :key="index">
        <i class="item-rank">{{index+1}}</i>
        <div class="item-name-num">
          <span class="item-name">{{item.name}}</span>
          <em class="item-num">{{item.num}}</em>
        </div>
      </div>-->
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      name: '溯源企业活跃度',
      data: [
        { name: '广西百色翠丰特色农产品有限责任公司', num: 90 },
        { name: '广西百色盛泰和农业有限公司', num: 81 },
        { name: '广西田阳新靖田农产品贸易有限公司', num: 72 },
        { name: '广西田阳穗丰园农产品贸易有限公司', num: 60 },
        { name: '广西田阳天穗农产品贸易有限公司', num: 57 },
        { name: '田阳县蔬心特色农产品经营部', num: 49 },
        { name: '广西田阳骄阳农产品贸易有限公司', num: 37 },
        { name: '蔬心特色农产品经营部', num: 28 },
        { name: '广西蔬心特色农产品经营部', num: 19 }
      ],
      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#0092ee'],
      lengthList: [356, 330, 310, 280, 250, 230, 210, 190, 160, 120],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
    changeColor(index) {
      if (index <= 3) {
        return `background:${this.colorList[index]}`
      } else {
        return `background:${this.colorList[3]}`
      }
    },
    changeLength(index) {
      return `width:${this.lengthList[index]}px`
    }
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?33a9d196